import { ERROR } from "@Components/Toast";
import { addNotification } from "@Store/Actions/Notifications";
import React from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { passwordReset } from "@Api/Auth";
import Button from "@Components/Button";
import Form, { InputType } from "@Components/Form";
import BackArrow from "@Components/Icons/BackArrow";
import PredictyIconEyesOpen from "@Components/Icons/ChatBot/Predicty/PredictyEyesOpen";
import CheckCircle from "@Components/Icons/CheckCircle";
import buttons from "@Components/Sass/buttons.module.scss";
import GetPath from "@Helpers/GetPath";
import { LOGIN } from "@Shared/Paths/Auth";
import styles from "./../Login/index.module.scss";
class PasswordReset extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: { password: "", confirmPassword: "" },
            errors: {},
            resetSuccess: false,
        };
    }
    inputChange = (data) => {
        this.setState({ data });
    };
    resetPassword = async () => {
        const { password, confirmPassword } = this.state.data;
        this.setState({ errors: {} });
        if (password !== confirmPassword) {
            this.setState({
                errors: { confirmPassword: "Passwords do not match" },
            });
            this.props.notify({
                title: "Failed to Reset",
                description: "Passwords don't match",
                status: ERROR,
            });
            return;
        }
        try {
            await passwordReset(this.props.resetId, password);
            this.setState({ resetSuccess: true });
        }
        catch (error) {
            const message = error.response?.data?.fails ||
                error.message ||
                "Failed to reset password.";
            this.props.notify({
                title: "Failed to Reset Password",
                description: message,
                status: ERROR,
            });
            this.setState({
                errors: { apiError: true },
            });
        }
    };
    render() {
        if (this.state.resetSuccess) {
            return (React.createElement("div", { className: styles.mainContent },
                React.createElement("div", { className: styles.centered },
                    React.createElement("div", { className: styles.successIcon },
                        React.createElement(CheckCircle, null))),
                React.createElement("div", { className: styles.heading },
                    React.createElement("h1", { className: styles.title }, "Password reset"),
                    React.createElement("p", { className: styles.subtitle }, "Your password has been successfully reset. Click below to log in magically.")),
                React.createElement("div", { className: styles.continueButton },
                    React.createElement(NavLink, { to: GetPath(LOGIN), className: styles.continueLink }, "CONTINUE TO LOGIN"))));
        }
        return (React.createElement("div", { className: styles.mainContent },
            React.createElement("div", { className: styles.centered },
                React.createElement(PredictyIconEyesOpen, { className: styles.logo })),
            React.createElement("div", { className: styles.heading },
                React.createElement("h1", { className: styles.title }, "Set new password"),
                React.createElement("p", { className: styles.subtitle }, "Your new password must be different to previously used passwords.")),
            React.createElement(Form, { className: styles.form, submit: this.resetPassword, labelLeft: false, input: [
                    {
                        label: "Password",
                        name: "password",
                        className: styles.inputForm,
                        inputClassName: styles.inputInner,
                        type: InputType.PasswordNew,
                        labelTooltip: "Must be at least 8 characters long and contain at least one special character.",
                    },
                    {
                        label: "Confirm Password",
                        name: "confirmPassword",
                        className: styles.inputForm,
                        inputClassName: styles.inputInner,
                        type: InputType.PasswordNew,
                        labelTooltip: "Must be at least 8 characters long and contain at least one special character.",
                    },
                ], buttons: false, change: this.inputChange, data: this.state.data, errors: this.state.errors },
                React.createElement("div", { className: styles.login },
                    React.createElement("div", { className: `${buttons.buttonGroupCenter} ${styles.noMargin}` },
                        React.createElement(Button, { cta: true, type: "submit" }, "RESET PASSWORD")))),
            React.createElement("div", { className: styles.backToLoginSection },
                React.createElement(NavLink, { to: GetPath(LOGIN), className: styles.backToLogin },
                    React.createElement(BackArrow, null),
                    "Back to log in"))));
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        // dispatching plain actions
        notify: (data) => addNotification(dispatch, data),
    };
};
export default connect(null, mapDispatchToProps)(PasswordReset);
